import { createBrowserRouter } from "react-router-dom";
import {REWARD, ENTRY, PROFILE} from "./constants/urls";
import AppErrorBoundary from "app-error-boundary";
import authRoutes from "modules/auth/auth-routes";
import rewardRoutes from "./modules/reward/reward-routes";
import profileRoutes from "./modules/profile/profile-routes";

const router = createBrowserRouter(
  [
    {
      path: ENTRY,
      lazy: () => import("./app"),
      ErrorBoundary: AppErrorBoundary,
      children: [
        {
          lazy: () => import("./app-public"),
          children: [
            {
              lazy: () => import("modules/auth/auth"),
              children: authRoutes,
            },
          ],
        },
        {
          lazy: () => import("./app-protected"),
          children: [
            {
              path: REWARD,
              lazy: () => import("./modules/reward/reward"),
              children: rewardRoutes
            },
            {
              path: PROFILE,
              lazy: () => import("./modules/profile/profile"),
              children: profileRoutes
            },
          ],
        },
      ],
    },
  ],
  // { basename: "/shop" },
);

export default router;
